import React, { useState } from 'react';
import { motion } from 'motion/react';
import { Cross2Icon } from '@radix-ui/react-icons';
import { Button } from '../common/Button';
import { Card, CardContent } from '../common/Card';
import { Input } from '../common/Input';
import { createActivity } from '../../api/activity';
import { useToast } from "../../hooks/useToast";

const QuickAddActivity = ({ onClose, onActivityAdded }) => {
  const { toast } = useToast();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    try {
      setLoading(true);
      const newActivityId = await createActivity(name);
      toast({
        title: "Success",
        description: "Activity created successfully",
        type: "success"
      });
      onActivityAdded(newActivityId, name);
      setName('');
      onClose();
    } catch (error) {
      toast({
        title: "Error",
        description: error.message || 'Failed to create activity',
        type: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: 'auto', opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      transition={{ duration: 0.2 }}
      className="overflow-hidden"
    >
      <Card className="border-dashed">
        <CardContent className="pt-6">
          <form onSubmit={handleSubmit} className="grid grid-cols-[1fr,auto] gap-4">
            <Input
              placeholder="Enter activity name..."
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full focus-visible:ring-0 border-none bg-muted/50"
              autoFocus
            />
            <div className="flex items-center gap-2">
              <Button type="submit" disabled={loading || !name.trim()}>
                Add Activity
              </Button>
              <Button type="button" variant="ghost" size="icon" onClick={onClose}>
                <Cross2Icon className="h-4 w-4" />
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default QuickAddActivity; 